"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnnouncementsEndpoints = createAnnouncementsEndpoints;
/**
 * Organizatör duyuruları (Story 1 uçları, Story 3 test gönderimi, Story 4 gönderim).
 *
 * KIRMIZI ÇİZGİ: yanıtlar alıcı kimliği, adı ya da adresi TAŞIMAZ; istemci yalnız
 * küme anahtarı gönderir ve SAYI okur. Gönder, zamanla, iptal ve durum Story 4'tür.
 */
function createAnnouncementsEndpoints(client) {
    return {
        announcements: {
            list: (eventId) => client.call('/events/{eventId}/announcements', 'get', { path: { eventId } }),
            /** Kümeler + (verildiyse) seçili kümelerin birleşimindeki kişi sayısı. */
            audiences: (eventId, audiences) => client.call('/events/{eventId}/announcements/audiences', 'get', {
                path: { eventId },
                query: audiences && audiences.length > 0 ? { audiences: audiences.join(',') } : {},
            }),
            detail: (eventId, announcementId) => client.call('/events/{eventId}/announcements/{announcementId}', 'get', {
                path: { eventId, announcementId },
            }),
            create: (eventId, input) => client.call('/events/{eventId}/announcements', 'post', {
                path: { eventId },
                body: input,
            }),
            update: (eventId, announcementId, input) => client.call('/events/{eventId}/announcements/{announcementId}', 'patch', {
                path: { eventId, announcementId },
                body: input,
            }),
            /** 204; alıcı yalnız oturumdaki kurum hesabıdır (adres gönderilmez). */
            sendTest: (eventId, announcementId) => client.call('/events/{eventId}/announcements/{announcementId}/test', 'post', {
                path: { eventId, announcementId },
            }),
            /** Story 4: hemen gönder. Gövde boş; alıcı kümesi sunucuda şimdi hesaplanır. */
            send: (eventId, announcementId) => client.call('/events/{eventId}/announcements/{announcementId}/send', 'post', {
                path: { eventId, announcementId },
            }),
            /** Story 4: an saat dilimi taşır (`+03:00` ya da `Z`); sınırlar sunucuda denetlenir. */
            schedule: (eventId, announcementId, input) => client.call('/events/{eventId}/announcements/{announcementId}/schedule', 'post', {
                path: { eventId, announcementId },
                body: input,
            }),
            /** Story 4: yalnız zamanlanmış ya da dağıtımdaki duyuru; aksi 409. */
            cancel: (eventId, announcementId) => client.call('/events/{eventId}/announcements/{announcementId}/cancel', 'post', {
                path: { eventId, announcementId },
            }),
            /** Story 4: hedef ve ileti toplamları; kişi bazlı satır yok, kırılım eşikli. */
            status: (eventId, announcementId) => client.call('/events/{eventId}/announcements/{announcementId}/status', 'get', {
                path: { eventId, announcementId },
            }),
        },
        /**
         * TEK TIK RET (Story 2, tasarım kare 10). OTURUMSUZDUR: yetki yoldaki imzalı
         * jetondur. `GET` yan etkisizdir; reti `POST` uygular, ikinci `POST` hata
         * vermez. Ret sayfası reti tarayıcıda (betik çalışınca) uygular: bağlantıyı
         * yalnız açan posta tarayıcısı reti tetiklemez.
         */
        announcementUnsubscribe: {
            inspect: (token) => client.call('/announcement-unsubscribe/{token}', 'get', { path: { token } }),
            apply: (token) => client.call('/announcement-unsubscribe/{token}', 'post', { path: { token }, body: {} }),
            /** "Geri al": pencere dışında 409 (`ANNOUNCEMENT_UNSUBSCRIBE_UNDO_UNAVAILABLE`). */
            undo: (token) => client.call('/announcement-unsubscribe/{token}/undo', 'post', { path: { token } }),
        },
    };
}
//# sourceMappingURL=announcements.js.map